// extracted by mini-css-extract-plugin
module.exports = {"product_skeleton_container":"SkeletonLoader_product_skeleton_container__1hKed"};